// Module
var code = "<div class=\"body main sign-in\"> <div v-if=\"isShowHeader && !isFaqLayout\" class=\"set_header_show main_login\"> <main-header/> </div> <header-error v-if=\"!isFaqLayout\"/> <router-view/> <modal-message v-if=\"!isFaqLayout\"/> <loading/> <main-footer v-if=\"!isFaqLayout\"/> </div> ";
// Exports
export default code;